import styled from 'styled-components';

export const AboutPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const TextBlock = styled.div`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const ImageBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const List = styled.ul`
  margin: 0;
  padding-left: 20px;
  font-size: 0.95rem;
`;

export const BranchesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BranchCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 0.9rem;
`;

export const BranchName = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const BranchMeta = styled.div`
  font-size: 0.8rem;
  color: #555555;
`;

export const DepartmentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const DepartmentCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 0.9rem;
`;

export const DepartmentName = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const DepartmentType = styled.div`
  font-size: 0.8rem;
  color: #555555;
  margin-bottom: 8px;
`;

export const LeadershipGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const LeaderCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 0.9rem;
`;

export const LeaderName = styled.div`
  font-weight: 600;
  margin-top: 8px;
`;

export const LeaderTitle = styled.div`
  font-size: 0.8rem;
  color: #555555;
  margin-bottom: 8px;
`;

export const StatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 0.95rem;
`;

export const StatItem = styled.div`
  min-width: 140px;
`;
